import { render, staticRenderFns } from "./SpaceyDashboard.vue?vue&type=template&id=a4cce9de&scoped=true"
import script from "./SpaceyDashboard.vue?vue&type=script&lang=js"
export * from "./SpaceyDashboard.vue?vue&type=script&lang=js"
import style0 from "./SpaceyDashboard.vue?vue&type=style&index=0&id=a4cce9de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cce9de",
  null
  
)

export default component.exports